import { render } from "./PrintCheckModal.vue?vue&type=template&id=faf3d1ee&scoped=true"
import script from "./PrintCheckModal.vue?vue&type=script&lang=js"
export * from "./PrintCheckModal.vue?vue&type=script&lang=js"

import "./PrintCheckModal.vue?vue&type=style&index=0&id=faf3d1ee&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf3d1ee"]])

export default __exports__